module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "akvamir"
  }, [_c('div', _vm._l((_vm.scenario.parameters.answers), function(answer) {
    return _c('div', {
      staticClass: "answer_shell",
      class: answer.theme === 'start' ? 'start' : ''
    }, [_c('answer', {
      attrs: {
        "answer-title": answer.title,
        "answer-theme": answer.theme,
        "answer-words": answer.words,
        "answer-audio": answer.audio,
        "answer-text": answer.text,
        "answer-speaker": answer.speaker,
        "answer-emotion": answer.emotion,
        "answer-speed": answer.speed,
        "is-saved": _vm.isSaved,
        "client": _vm.scenario.client
      },
      on: {
        "update:answerAudio": function($event) {
          return _vm.$set(answer, "audio", $event)
        },
        "update:answer-audio": function($event) {
          return _vm.$set(answer, "audio", $event)
        },
        "update:answerText": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answer-text": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answerSpeaker": function($event) {
          return _vm.$set(answer, "speaker", $event)
        },
        "update:answer-speaker": function($event) {
          return _vm.$set(answer, "speaker", $event)
        },
        "update:answerEmotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answer-emotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answerSpeed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "update:answer-speed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "generateAudioHandler": _vm.setAudio,
        "deleteAudioHandler": _vm.deleteAudio
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.isSaved,
      "is-ready": _vm.scenario.isReady,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f99736a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/ScenarioAkvamir.vue
// module id = 540
// module chunks = 42